<template>
    <div class="recharge-container">
        <div class="content-wrapper">
            <div class="qr-box">
                <div >
                    <vue-qr :logoSrc="qrPath" :text="props.address" :size="size" :quality="quality" :colorDark="'#000'"
                        :colorLight="'#fff'">
                    </vue-qr>
                </div>
            </div>

            <div class="address-section">
                <div class="label">{{ $t('recharge.Address') }}</div>
                <van-row class="custom-field">
                    <van-col span="20" class="ellipsis-text">{{ props.address }}</van-col>
                    <van-col span="4">
                        <van-button size="small" type="primary" class="copy-btn" @click="onCopy">
                            {{$t('recharge.CopyLink')}}
                        </van-button>
                    </van-col>
                </van-row>
            </div>

            <div class="info-grid">
                <div class="info-item">
                    <span class="info-label">{{$t('recharge.mainNet')}}</span>
                    <span class="info-value">ERC20</span>
                </div>
                <div class="info-item text-right">
                    <span class="info-label">{{$t('recharge.chargingRange')}}</span>
                    <span class="info-value highlight">{{ props.minAmount }} - {{ props.maxAmount }} USDT</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { showToast } from 'vant';
import 'vant/es/toast/style';
import VueQr from 'vue-qr/src/packages/vue-qr.vue';
const props = defineProps({
    address: {
        type: String,
        default: ''
    },
    minAmount: {
        type: String,
        default: ''
    },
    maxAmount: {
        type: String,
        default: ''
    },
})
const qrPath = ref('')
const size = ref(200)
const quality = ref('H')
const onCopy = () => {
    navigator.clipboard.writeText(props.address);
    showToast('Address Copied');
};
</script>

<style scoped>
.recharge-container {
    background-color: #0a0a0a;
    color: white;
    display: flex;
    justify-content: center;
    padding: 10px;
    border-radius: 10px;
}

.content-wrapper {
    width: 100%;
    max-width: 350px;
}

.qr-box {
    padding: 20px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}

.address-section .label {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
}

.custom-field {
    background-color: #000 !important;
    border: 1px solid #333;
    border-radius: 8px;
    padding: 0 0 0 5%;
    color: #fff;
    font-family: monospace;
    font-size: 12px;
    display: flex;
    align-items: center;
}

.copy-btn {
    background-color: #fd66b1;
    border: none;
    height: 36px;
    padding: 0 20px;
    border-radius: 6px;
}

.info-grid {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}

.info-item {
    display: flex;
    flex-direction: column;
}

.info-label {
    color: #888;
    font-size: 12px;
    margin-bottom: 4px;
}

.info-value {
    font-weight: bold;
    font-size: 14px;
}

.highlight {
    color: #ff75d2;
}

.text-right {
    text-align: right;
}

.ellipsis-text {
    white-space: nowrap;     
    overflow: hidden; 
    text-overflow: ellipsis;
    display: block;
}
</style>